import { broadcastChannelService } from "../shared/broadcastChannelService";
import { LOCALE_RU } from "../constant";
import { FORMS_URL, getFetchRequest, postFetchRequest } from "../store/requests";
import { formsStorage } from "./formsStorage";
import {errorCallback, makeUrl} from "../util";
import i18n from "../i18nService";
import { createFormGroupsList } from "../components/helper";

const prepareFormData = (form) => {
    const result = {};
    if(form.formGroup) {
        result.formGroup = form.formGroup;
    }
    if(form.formType) {
        result.formType = form.formType;
    }
    return result;
};

export const findCodeValue = (value, key, array) => {
    let result = '';
    array.forEach(it => it[key] === value ? result = it.id : null);
    return result;
};

export const formSaveService = {
    currentForm: {},
    lastFormUpdateTime: null,
    formUpdateObservers: [],
    loadForm(formId, callback, i18nInstance = i18n) {
        try {
            getFetchRequest(makeUrl([FORMS_URL, formId, '/']), (response) => {
                this.currentForm = {
                    ...response,
                    names: response.names || [],
                    locale: LOCALE_RU,
                };
                this.notifyFormUpdateObservers();
                callback(response);
            }, errorCallback);
        } catch(err) {
            console.log(err);
        }
    },
    getForm() {
        return this.currentForm;
    },
    getDateLastUpdate() {
        return this.lastFormUpdateTime;
    },
    registerItemUpdateObserver(observer) {
        this.formUpdateObservers.push(observer);
    },
    unRegisterItemUpdateObserver(observer) {
        this.formUpdateObservers = this.formUpdateObservers.filter(formUpdateFunction => formUpdateFunction !== observer);
    },
    notifyFormUpdateObservers() {
        this.formUpdateObservers.forEach(formUpdateFunction => formUpdateFunction(this.currentForm));
    },
    updateFormName(locale, value) {
        try {
            postFetchRequest(makeUrl([FORMS_URL, this.currentForm.id, '/name/']),
                {
                    localizedName: value,
                    locale: locale,
                },
                () => {
                    if (!this.currentForm.names) {
                        this.currentForm.names = [];
                    }
                    const existing = this.currentForm.names.find((it) => it.locale === locale);
                    if (existing) {
                        existing.name = value;
                    } else {
                        this.currentForm.names.push({
                            locale: locale,
                            name: value,
                        });
                    }
                    const storedForm = formsStorage.getById(this.currentForm.id);
                    if (storedForm) {
                        storedForm.names = [...this.currentForm.names];
                    }
                    this.lastFormUpdateTime = Date.now();
                    this.notifyFormUpdateObservers();
                }, errorCallback, true);
        } catch(err) {
            console.log(err);
        }
    },
    updateItemLocalization(locale, value) {
        this.updateFormName(locale, value);
    },
    updateFormValue(filedName, value) {
        try {
            this.currentForm[filedName] = value;
            this.lastFormUpdateTime = Date.now();
            this.notifyFormUpdateObservers();
            this.updateForm();            
        } catch(err) {
            console.log(err);
        }
    },
    updateForm() {
        try {
            postFetchRequest(makeUrl([FORMS_URL, this.currentForm.id, '/']), prepareFormData(this.currentForm), () => {
                broadcastChannelService.sendFormUpdateMessage();
            }, errorCallback, true);
        } catch(err) {
            console.log(err);
        }
    },
    getLabelValue(i18nInstance = i18n) {
        return i18nInstance.t('app.page.product.addFormItem.formGroup');
    },
    getProductCategory() {
        return this.currentForm.formGroup;
    },
    getFormGroupOptions() {
        return createFormGroupsList(this.needToAddAny());
    },
    updateProductCategory(value) {
        this.currentForm['formGroup'] = value;
        this.lastFormUpdateTime = Date.now();
        this.notifyFormUpdateObservers();
        this.updateForm();    
    },
    needToAddAny() {
        return true;
    },
};
